var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrsRoundCurrency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    fill: "#272B34"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 46.5,
    stroke: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.231 35.9181C53.4626 33.2901 50.1712 31.8988 46.357 31.8988C43.3118 31.8988 40.2973 31.8988 37.2521 31.8988C37.1598 31.8988 37.0367 31.8988 36.8829 31.9297C36.9752 32.0533 37.0367 32.1152 37.0675 32.1461C38.2056 33.2901 39.4053 34.4031 40.4511 35.6089C41.2201 36.4746 42.0199 36.8147 43.1887 36.7529C44.7267 36.6601 46.3262 36.6601 47.8642 36.8765C51.0633 37.3094 53.4318 39.1026 54.8775 41.9471C56.6924 45.5026 56.354 48.9963 53.9547 52.2118C52.2014 54.5306 49.8636 55.7983 46.9414 55.9219C45.2804 55.9838 43.6501 55.9529 41.9891 55.9838C41.7738 55.9838 41.5277 56.0765 41.4047 56.2311C40.3281 57.3133 39.2515 58.4263 38.1749 59.5084C37.775 59.9104 37.3443 60.2814 36.9137 60.6524C36.9445 60.7142 36.9752 60.7451 37.006 60.807C37.0983 60.807 37.1905 60.807 37.2828 60.807C40.3588 60.807 43.4656 60.807 46.5416 60.807C47.8335 60.807 49.0639 60.6215 50.2943 60.2814C54.17 59.1065 57.123 56.7258 59.0916 53.1703C60.5066 50.5732 61.0295 47.8215 60.7219 44.9152C60.322 41.2978 58.784 38.3297 56.231 35.9181Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 0,
    y: 0,
    width: 99,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.3513,
    y1: 86.8513,
    x2: 117.351,
    y2: 15.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDF96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrsRoundCurrency);
export default __webpack_public_path__ + "static/media/drs-round-currency.0bc89710a85562e0e4eb656f52a75e9f.svg";
export { ForwardRef as ReactComponent };